// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer_NPD_k","cards":"Footer_cards_fbA0Y","info":"Footer_info_A4YwE"};